export const trustValue = (value: unknown): boolean => {
  return value !== null && value !== undefined;
}
